import { Inject, Injectable } from '@angular/core';
import { BaseEndpoint } from '../app.constants';
import { Http } from '@angular/http';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { LoanChannelDto, LoanPurposeDto, PipelineLoanDto, TeamBalancerDto, TeamBalancerSubmitDto, UnderwriterDto, UnderwriterTeamBalancerBatchRecordDto } from './uwteambalancer.model';

@Injectable()
export class UnderwriterTeamBalancerService
{

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl: string, private adalService: AdalService) { }

    getLoanChannels(): Promise<LoanChannelDto[]> {
        var url = this.baseApiUrl + 'v1/loanchannels';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var strats = resp.json().body as LoanChannelDto[];
                var loanChannels = JSON.parse(JSON.stringify(strats));
                return loanChannels;
            })
            .catch(this.handleError);
    }

    getLoanPurposes(): Promise<LoanPurposeDto[]> {
        var url = this.baseApiUrl + 'v1/loanpurposes';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var strats = resp.json().body as LoanPurposeDto[];
                var loanPurposes = JSON.parse(JSON.stringify(strats));
                return loanPurposes;
            })
            .catch(this.handleError);
    }

    getLoansToBalance(teamBalancerDto: TeamBalancerDto): Promise<PipelineLoanDto[]> {
        const url = this.baseApiUrl + 'v1/teamBalancer/getLoans';
        
        return this.http
            .post(url, JSON.stringify(teamBalancerDto), { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    balanceLoans(teamBalancerSubmitDto: TeamBalancerSubmitDto): Promise<UnderwriterDto> {
        const url = this.baseApiUrl + 'v1/teamBalancer/balanceLoans';

        return this.http
            .post(url, JSON.stringify(teamBalancerSubmitDto), { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    recordBatch(teamBalancerSubmitDto: UnderwriterTeamBalancerBatchRecordDto): Promise<boolean> {
        const url = this.baseApiUrl + 'v1/teamBalancer/recordBatch';

        return this.http
            .post(url, JSON.stringify(teamBalancerSubmitDto), { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    getUnderwriters() {
        const url = this.baseApiUrl + 'v1/teamBalancer/getUnderwriters';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader()})
            .toPromise()
            .then(resp => {
                return resp.json().body;
            })
            .catch(this.handleError);
    }

    private handleError(errors: string[]): Promise<any> {
        console.error('An error occurred', errors);
        return Promise.reject(errors);
    }
}






// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/uw-team-balancer/uwteambalancer.service.ts